import { Component } from '@angular/core';
import { Platform, IonicPage, NavController, NavParams, LoadingController, AlertController, ActionSheetController } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { TranslateService } from '@ngx-translate/core';

import { Scenario } from '../../models/scenario.model';
import { Incident } from '../../models/incident.model';
import { ScenarioProvider } from '../../providers/scenario/scenario';
import { IncidentProvider } from "../../providers/incident/incident";

import { LoginPage } from '../auth/login';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-incident-reporting',
  templateUrl: 'incident-reporting.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class IncidentReportingPage {

  loading: boolean;
  scenarios: Scenario[];
  newIncident: Incident;

  tab: string = 'incident';

  constructor(public platform: Platform, public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public actionSheetCtrl: ActionSheetController, private camera: Camera, public incidentProvider: IncidentProvider, public scenarioProvider: ScenarioProvider) {
    this.newIncident = new Incident({
      scenario_id: 0,
      content: '',
      picture: ''
    });
  }

  getScenarios() {
    this.loading = true;
    this.scenarioProvider.getAll()
      .subscribe(
        scenarios => this.scenarios = scenarios,
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }

  getBase64Image(imageData: string) {
    return `data:image/jpeg;base64,${imageData}`;
  }

  selectPicture() {
    let actionSheet = this.actionSheetCtrl.create({
      title: this.translate.instant('ACTION_SHEETS_PICTURE_TITLE'),
      buttons: [
        {
          text: this.translate.instant('ACTION_SHEETS_TAKE_PICTURE'),
          icon: !this.platform.is('ios') ? 'camera' : null,
          handler: () => {
            this.takePicture();
          }
        }, {
          text: this.translate.instant('ACTION_SHEETS_OPEN_LIBRARY'),
          icon: !this.platform.is('ios') ? 'images' : null,
          handler: () => {
            this.openLibrary();
          }
        }, {
          text: this.translate.instant('ACTION_SHEETS_CANCEL'),
          role: 'cancel',
          icon: !this.platform.is('ios') ? 'close' : null
        }
      ]
    });
    actionSheet.present();
  }

  openLibrary() {
    const options: CameraOptions = {
      quality: 80,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY
    };

    this.camera.getPicture(options).then((imageData) => {
      this.newIncident.picture = imageData;
     }, (err) => {
      console.log(err);
     });
  }

  takePicture() {
    const options: CameraOptions = {
      quality: 80,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.CAMERA
    };

    this.camera.getPicture(options).then((imageData) => {
      this.newIncident.picture = imageData;
     }, (err) => {
      console.log(err);
     });
  }

  canSend() {
    return (this.newIncident.scenario_id && this.newIncident.content);
  }

  send() {
    let loading = this.loadingCtrl.create({
      content: this.translate.instant('MSG_PLEASE_WAIT')
    });

    loading.present();

    let values = {
      scenario_id: this.newIncident.scenario_id,
      content: this.newIncident.content,
      picture: this.newIncident.picture || null
    };

    this.incidentProvider.report(values)
      .subscribe(
        incident => {
          this.newIncident = new Incident({
            scenario_id: 0,
            content: '',
            picture: ''
          });
        },
        error => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_ERROR_TITLE'),
            subTitle: this.translate.instant('MODAL_ERROR_INCIDENT_REPORT'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
        },
        () => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_SUCCESS_TITLE'),
            subTitle: this.translate.instant('MODAL_SUCCESS_INCIDENT_REPORT'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
        }
      );
  }

  ionViewDidLoad() {
    this.getScenarios();
  }

}



// WEBPACK FOOTER //
// ./src/pages/incident-reporting/incident-reporting.ts